import { authedRequest, unauthedRequest } from "./requests";

/**
 *
 * /Galeries resource requests
 *
 */

export const getGallery = ({ slug, params }) => {
  return unauthedRequest(`v2/channels/${slug}/load-gifs${params}`, {
    method: "GET",
  });
};

export const deleteGallery = (token, { gifId }) => {
  return (
    authedRequest(`v2/gifs/${gifId}`, token, { method: 'DELETE' }).then(r => r));
}